import __request__ from "routing/request";
export function getContentStreamUserSettings(username) {
  return __request__("GET", `/contentstream/settings/${username}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function setContentStreamUserSettings(JSONbody, username) {
  return __request__("PUT", `/contentstream/settings/${username}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getContentStreamTags() {
  return __request__("GET", "/contentstream/tags", null, {}, {
    "Accept": ["application/json"]
  });
}
